import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { flatMap, uniq, isEmpty, isNil } from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Chip from '@material-ui/core/Chip';
import { useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MaterialUILink from '@material-ui/core/Link';
import { useDispatch, useSelector } from 'react-redux';
import { setAssetFilters, fetchAssetFilterCount } from '../../redux/actions/resultsActions';
import FilterLabel from './FilterLabel';

const useStyles = makeStyles((theme) => ({
	clearFilters: {
		top: '25%',
	},
}));
const TagsFilter = ({ tags, selectedTags, isArchived, isBuyable }) => {
	const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
	const checkedIcon = <CheckBoxIcon fontSize="small" />;
	const dispatch = useDispatch();
	const handleChange = (event, value) => {
		dispatch(setAssetFilters({ isArchived, isBuyable, tags: value }));
	};
	return (
		<Autocomplete
			multiple
			id="checkboxes-tags-demo"
			options={tags}
			disableCloseOnSelect
			value={selectedTags}
			onChange={handleChange}
			getOptionLabel={(option) => option}
			renderTags={(value) => {
				const label = `${value.length} selected`;
				return <Chip variant="outlined" label={label} size="small" />;
			}}
			renderOption={(option, { selected }) => (
				<React.Fragment>
					<Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
					{option}
				</React.Fragment>
			)}
			style={{ width: 300 }}
			renderInput={(params) => <TextField {...params} variant="outlined" label="Tags" placeholder="Tags" />}
		/>
	);
};
const ArchivedFilter = ({ isArchived, isBuyable, tags }) => {
	const dispatch = new useDispatch();
	const archivedCount = useSelector((state) => state.results.assetFilterCount.archived);
	const handleChange = (event) => {
		dispatch(setAssetFilters({ isArchived: event.target.checked, isBuyable, tags }));
	};
	return (
		<FormControlLabel
			disabled={archivedCount === 0}
			control={
				<Checkbox
					checked={isArchived}
					color="primary"
					onChange={handleChange}
					inputProps={{ 'aria-label': 'primary checkbox' }}
				/>
			}
			label={<FilterLabel message="Show Only Archived items" count={archivedCount} />}
		/>
	);
};

const ShowNonBuyableFilter = ({ isBuyable, isArchived, tags }) => {
	const dispatch = new useDispatch();
	const buyableCount = useSelector((state) => state.results.assetFilterCount.buyable);
	const handleChange = (event) => {
		dispatch(setAssetFilters({ isArchived, isBuyable: !event.target.checked, tags }));
	};
	return (
		<FormControlLabel
			disabled={buyableCount === 0}
			control={
				<Checkbox
					checked={!isBuyable}
					color="primary"
					onChange={handleChange}
					inputProps={{ 'aria-label': 'primary checkbox' }}
				/>
			}
			label={<FilterLabel message="Show Only non-buyable items" count={buyableCount} />}
		/>
	);
};

function AssetGridFilters({ assets, setFilteredAssets, query }) {
	// Get tags for all assets, and remove duplicates.
	const aTags = flatMap(assets, 'tags');
	const uniqueTags = uniq(aTags);
	const classes = useStyles();
	const dispatch = useDispatch();
	const assetFilters = useSelector((state) => state.results.assetFilters);
	const { isArchived, isBuyable, tags } = assetFilters;

	const ResetFilters = () => {
		dispatch(setAssetFilters({ isBuyable: true, isArchived: false, tags: [] }));
	};

	useEffect(() => {
		setFilteredAssets(assets);
		// fetch  filter projection count  (Non-Buyable and archived)
		if (!isEmpty(query) && !isNil(query)) {
			dispatch(fetchAssetFilterCount(query));
		}
	}, [assets, setFilteredAssets, dispatch, query]);

	return (
		<Grid container spacing={2}>
			<Grid item>
				<TagsFilter tags={uniqueTags} selectedTags={tags} isArchived={isArchived} isBuyable={isBuyable} />
			</Grid>
			<Grid item>
				<ArchivedFilter isArchived={isArchived} isBuyable={isBuyable} tags={tags} />
			</Grid>
			<Grid item>
				<ShowNonBuyableFilter isBuyable={isBuyable} isArchived={isArchived} tags={tags} />
			</Grid>
			<Grid item>
				<MaterialUILink
					component="button"
					variant="body2"
					onClick={() => {
						ResetFilters();
					}}
					className={classes.clearFilters}
				>
					Clear Filters
				</MaterialUILink>
			</Grid>
		</Grid>
	);
}

export default AssetGridFilters;
